import { Component, Input, OnInit } from '@angular/core';
import { RequirementField } from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.interface';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'ba-textarea',
    templateUrl: 'textarea-attribute.component.html'
})
export class TextAreaAttributeComponent implements OnInit {

    @Input() field: RequirementField;
    @Input() form: UntypedFormGroup;

    ngOnInit() { }

    get control() {
        return this.form.controls[this.field.alias];
    }
}
